import React from "react";


export const AuditStatusColumnFormatter = (cellContent, row) => (
  <span

    className={`label label-lg label-light-${getColor(row.status)
      } label-inline`}
  >
    {getTitle(row.status)}
  </span>
);

const getColor = (code) => {

  switch (code) {
    case "NotAllowed":
      return "danger";
    case "Enable":
      return "warning";
    case "NotCompleted":
      return "danger";
    case "MustConfirm":
      return "info";
    case "EnableMustConfirm":
      return "info";
    case "Completed":
      return "success";

    default:
      break;
  }
}

const getTitle = (code) => {

  switch (code) {
    case "NotAllowed":
      return "غیر مجاز";

    case "Enable":
      return "فعال جهت تکمیل کردن";

    case "NotCompleted":
      return "ناقص و غیرفعال";

    case "MustConfirm":
      return " نیاز به تایید نهایی و غیرفعال";

    case "EnableMustConfirm":
      return "پر شده و نیاز به تایید نهایی";

    case "Completed":
      return "تایید نهایی و تکمیل شده";

    default:
      break;
  }
}


export const AuditResultStatusColumnFormatter = (cellContent, row) => (
  <span

    className={`label label-lg label-light-${getColorRes(row.status)
      } label-inline`}
  >
    {getTitleRes(row.status)}
  </span>
);

const getColorRes = (code) => {

  switch (code) {
    case "NotCompleted":
      return "danger";
    case "Temp":
      return "warning";
    case "Completed":
      return "success";

    default:
      break;
  }
}

const getTitleRes = (code) => {

  switch (code) {
    case "NotCompleted":
      return "پاسخ داده نشده";

    case "Temp":
      return "پاسخ پیشنویس";

    case "Completed":
      return "تایید نهایی پاسخ";

    default:
      break;
  }
}